<template>
  <tr
    class="table-v2__body-row"
    :class="{ 'table-v2__body-row--clickable': clickable }"
    @click="$emit('click', $event)"
  >
    <slot />
  </tr>
</template>

<script>
export default {
  name: 'TableRowV2',
  props: {
    clickable: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.table-v2__body-row {
  background: theme('colors.white');

  &--clickable {
    cursor: pointer;
  }

  &:hover {
    background: theme('colors.neutral.50');
  }
}
</style>
